type SupportLogEntry = {
  ts: string;
  level: 'debug' | 'info' | 'warn' | 'error';
  scope: string;
  data?: any;
};

const MAX_SUPPORT_LOGS = 250;
const supportLogs: SupportLogEntry[] = [];

const REDACTED = '[REDACTED]';

const SENSITIVE_KEY_RE =
  /(token|jwt|authorization|password|secret|privatekey|private_key|ciphertext|cipherText|envelope|payload|body|messageBody|plaintext|plainText|media|blob|file|image|video|audio)/i;

export function redactForSupport(value: any, depth = 0): any {
  if (depth > 5) return '[MAX_DEPTH]';

  if (value == null) return value;

  if (typeof value === 'string') {
    if (value.length > 160) return value.slice(0, 80) + '…[truncated]';
    return value;
  }

  if (typeof value === 'number' || typeof value === 'boolean') return value;

  if (Array.isArray(value)) {
    return value.slice(0, 20).map((x) => redactForSupport(x, depth + 1));
  }

  if (typeof value === 'object') {
    const out: Record<string, any> = {};

    for (const [key, raw] of Object.entries(value)) {
      if (SENSITIVE_KEY_RE.test(key)) {
        out[key] = REDACTED;
      } else {
        out[key] = redactForSupport(raw, depth + 1);
      }
    }

    return out;
  }

  return String(value);
}

export function addSupportLog(
  level: SupportLogEntry['level'],
  scope: string,
  data?: any
) {
  supportLogs.push({
    ts: new Date().toISOString(),
    level,
    scope,
    data: redactForSupport(data),
  });

  while (supportLogs.length > MAX_SUPPORT_LOGS) {
    supportLogs.shift();
  }
}

export function getSupportLogs() {
  return supportLogs.slice();
}

export function clearSupportLogs() {
  supportLogs.length = 0;
}
